export const reframeGalaxyData = (galaxy) => {
    const reframeData = {}

    const galaxyData = galaxy.data

    reframeData["Info"] = {
        "name" : galaxyData.name,
        "designation": galaxyData.designation,
        "type": galaxyData.type,
        "stars": galaxyData.stars,
        "age": galaxyData.age,
        "group": galaxyData.group
    }

    reframeData["Properties"] = {
        "mass" : galaxyData["mass"],
        "diameter" : galaxyData["diameter"],
        "size" : galaxyData["size"],
        "redshift" : galaxyData["redshift"],
        "heliocentric_radial_velocity" : galaxyData["heliocentric_radial_velocity"],
        "apparent_magnitude" : galaxyData["apparent_magnitude"],
        "absolute_magnitude" : galaxyData["absolute_magnitude"],
        "right_ascension" : galaxyData["right_ascension"],
        "declination" : galaxyData["declination"],
        "distance" : galaxyData["distance"],
    }

    reframeData["Facts"] = {
        "fact": galaxyData.fact
    }

    reframeData["Source"] = {
        "images" : galaxyData.image
    }

    const galaxySystem = galaxy.systems
   
    reframeData["Systems"] = {
        "No of Systems" : Object.keys(galaxySystem).length,
    }


    return reframeData
}
